"use client";

import { useGlobalInteractionListener } from "@client/functions/custom-hooks/useGlobalInteractionListener";
import postEvent from "@server/front-end-api/postEvent";
import { USER_INTERACTION_DATA_ATTRIBUTE } from "@shared/constants";
import { usePathname } from "next/navigation";

export default function GlobalInteractionListenerSetup() {
	const pathname = usePathname();

	useGlobalInteractionListener(
		USER_INTERACTION_DATA_ATTRIBUTE,
		(_event, element, eventType) => {
			// console.log(
			// 	`${eventType} event on:`,
			// 	(element as HTMLElement).dataset.trackInteraction,
			// );

			switch (eventType) {
				case "click":
					// If the clicked element is a submit button, do not send an event
					// we already handle form submissions with a "submit" event
					if ((element as HTMLInputElement)?.type === "submit") return;

					postEvent(USER_INTERACTION_DATA_ATTRIBUTE, {
						path: pathname,
						dataTrackingAttributeValue:
							(element as HTMLElement).dataset.trackInteraction || "",
						target: element.outerHTML,
						eventType: eventType,
						eventValue: (element as HTMLInputElement)?.value,
						eventTimeStamp: new Date().toISOString(),
					});

					break;

				/**
				 * We can respond to other interaction types here as needed
				 * (e.g., 'keydown' for form submissions, 'change' for input changes)
				 * However, `click` is also fired when a user takes approrpiate actions
				 * like updating a selectbox, toggling accordions, typing Enter to submit a form, etc.)
				 */
				/*
				case "keydown":
					if (
						(event as KeyboardEvent).key === "Enter" ||
						(event as KeyboardEvent).key === "Space"
					) {
						console.log("Key pressed:", (event as KeyboardEvent).key);
					}
					break;
				case "toggle":
					console.log("Details toggled");
					break;
          case "submit":
            break;
            */

				// // Change event blows up database with too many events
				// // disabling it for now
				// case "change":
				// 	postEvent(USER_INTERACTION_DATA_ATTRIBUTE, {
				// 		path: pathname,
				// 		dataTrackingAttributeValue:
				// 			(element as HTMLElement).dataset.trackInteraction || "",
				// 		target: element.outerHTML,
				// 		eventType: eventType,
				// 		eventValue: (element as HTMLInputElement)?.value,
				// 		eventTimeStamp: new Date().toISOString(),
				// 	});
				// 	break;
				default:
			}
		},
	);

	return null;
}
